import { motion } from 'framer-motion';
import { useHistory } from 'react-router';
import { css } from 'styled-components';

import { LAST_ANIMATION_DELAY } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/constants';
import { SimpleFeatureLayout } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/SimpleFeatureLayout';
import { EscriptOnboardingStepName } from 'src/app/components/Pages/EscriptOnboarding/types';
import { medications } from 'src/app/router/paths';
import {
  ESCRIPT_ONBOARDING_ALLERGIES_FORM,
  ESCRIPT_ONBOARDING_FINISHED,
  ESCRIPT_ONBOARDING_OTHER_MEDS_FORM,
  ESCRIPT_ONBOARDING_STEP,
} from 'src/app/storage/localStorageKeys';

const mixBlendMultiply = css`
  mix-blend-mode: multiply;
`;

const DeliveryArt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 375 283">
    <path fill="#fff" d="M0 0h375v283H0z" />
    <circle cx="188" cy="141" r="105" fill="#DFECEA" />
    <path
      fill="#DFECEA"
      d="M113.61 53.48a3 3 0 0 1 3-2.9h104.56a3 3 0 0 1 3 2.9l5.93 175.48a3 3 0 0 1-3 3.1H110.7a3 3 0 0 1-3-3.1l5.92-175.48Z"
      css={mixBlendMultiply}
    />
    <path
      fill="#DBCABC"
      d="M108.03 48.9a3 3 0 0 1 3-2.9H215.6a3 3 0 0 1 3 2.9l5.93 175.48a3 3 0 0 1-3 3.1H105.1a3 3 0 0 1-3-3.1l5.93-175.48Z"
    />
    <path fill="#FFD300" d="M130.02 195.57h-9.62a3.7 3.7 0 0 0 0 7.38h9.62v-7.38Z" />
    <path fill="#99BFBC" d="M143.62 199.26a3.7 3.7 0 0 0-3.69-3.7h-9.9v7.4h9.9a3.69 3.69 0 0 0 3.69-3.7Z" />
    <path fill="#0F3C6C" d="M130.17 212.73a3.7 3.7 0 0 0 3.69-3.7v-13.46l-7.38 7.38v6.09c0 2.04 1.65 3.69 3.69 3.69Z" />
    <path fill="#EF4931" d="M130.17 185.79a3.7 3.7 0 0 0-3.69 3.7v13.46l7.37-7.38v-6.09c0-2.04-1.65-3.69-3.68-3.69Z" />
    <mask id="a" width="55" height="19" x="136" y="65" maskUnits="userSpaceOnUse">
      <rect width="53.95" height="18.1" x="136.34" y="65.62" fill="#DFECEA" rx="9.05" />
    </mask>
    <g mask="url(#a)">
      <rect width="53.95" height="18.1" x="136.34" y="65.62" fill="#DFECEA" rx="9.05" css={mixBlendMultiply} />
      <rect width="53.95" height="18.1" x="141.34" y="70.62" fill="#DFECEA" rx="9.05" />
    </g>

    <motion.g
      id="calender-illustration"
      animate={{
        rotate: [0, 5, 5, 0],
      }}
      transition={{
        type: 'spring',
        repeat: Infinity,
        duration: 2,
        delay: LAST_ANIMATION_DELAY,
      }}
    >
      <rect
        width="92.55"
        height="92.55"
        x="195.55"
        y="109.02"
        fill="#DFECEA"
        rx="3"
        css={mixBlendMultiply}
        transform="rotate(10 195.55 109.02)"
      />
      <mask id="b" width="108" height="107" x="174" y="104" maskUnits="userSpaceOnUse">
        <rect
          width="92.55"
          height="92.55"
          x="190.58"
          y="104.08"
          fill="#D9D9D9"
          rx="3"
          transform="rotate(10 190.58 104.08)"
        />
      </mask>
      <g mask="url(#b)">
        <path fill="#fff" d="m190.58 104.08 91.14 16.07-16.07 91.14-91.14-16.07z" />
        <path fill="#EF4931" d="m188.16 100.62 97.02 17.1-5.44 30.88-97.02-17.1z" />
      </g>
      <rect
        width="7.78"
        height="18.51"
        x="235.05"
        y="102.58"
        fill="#0F3C6C"
        rx="3.89"
        transform="rotate(10 235.05 102.58)"
      />
      <rect
        width="7.78"
        height="18.51"
        x="260.98"
        y="107.15"
        fill="#0F3C6C"
        rx="3.89"
        transform="rotate(10 260.98 107.15)"
      />
      <rect width="7.78" height="18.51" x="209.1" y="98" fill="#0F3C6C" rx="3.89" transform="rotate(10 209.1 98)" />
      <path
        stroke="#0F3C6C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8"
        d="m206.82 167.37 11.52 16.9 36.15-26"
      />
    </motion.g>
  </svg>
);

export const EscriptOnboardingEnd = () => {
  const history = useHistory();

  return (
    <SimpleFeatureLayout
      keyName={EscriptOnboardingStepName.end}
      title={`Now let’s schedule your first delivery`}
      body={{
        content: <DeliveryArt />,
        type: 'artwork',
      }}
      cta1={{
        children: 'Got it',
        onClick: () => {
          window.localStorage.removeItem(ESCRIPT_ONBOARDING_ALLERGIES_FORM);
          window.localStorage.removeItem(ESCRIPT_ONBOARDING_OTHER_MEDS_FORM);
          window.localStorage.removeItem(ESCRIPT_ONBOARDING_STEP);
          window.localStorage.setItem(ESCRIPT_ONBOARDING_FINISHED, 'true');
          history.push(medications.route);
        },
      }}
    />
  );
};
